import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
   Linkedin,
   Instagram,
   Facebook,
   Mail,
   Phone,
   MapPin,
   Factory,
   Globe,
   ArrowRight,
   ShieldCheck,
   Zap,
   Box,
   CircleDashed,
   Paperplane
} from "lucide-react";
import Logo from "../img/spinoff-light-logo.png";
import "../css/footer.css";

const Footer = () => {
   const [email, setEmail] = useState("");
   const [message, setMessage] = useState("");

   const handleSubscribe = async (e) => {
      e.preventDefault();
      if (!email) {
         setMessage("Please enter your email.");
         return;
      }
      try {
         const response = await fetch(
            `${process.env.REACT_APP_BASE_Backend_URL}/emailsubscribe/submitsubscribemail`,
            {
               method: "POST",
               headers: { "Content-Type": "application/json" },
               body: JSON.stringify({ email }),
            }
         );
         const data = await response.json();
         setMessage(data.message);
         if (response.ok) setEmail("");
      } catch (error) {
         setMessage("Something went wrong. Please try again later.");
      }
   };

   return (
      <footer className="site-footer">
         <div className="footer-hero-blob fh-blob-1"></div>
         <div className="footer-hero-blob fh-blob-2"></div>

         <div className="footer-container">

            {/* COMPACT BENTO GRID - EXACT USER CONTENT MAPPING */}
            <div className="footer-bento-grid" style={{ gap: '24px' }}>

               {/* SECTION 1: ABOUT & SOCIALS */}
               <div className="f-glass-card">
                  <Link to="/" style={{ display: 'block', marginBottom: '16px' }}>
                     <img src={Logo} alt="Spinoff Logo" style={{ height: '32px' }} />
                  </Link>
                  <p style={{ fontSize: '13px', lineHeight: '1.6' }}>
                     SPINOFF Technopark Ltd, having its Corporate office in Chandigarh, and two manufacturing units in Punjab leads in SMART LED lighting, Inverters & Lithium Battery Energy solutions with over 35 years of industry expertise and cutting-edge manufacturing capabilities.
                  </p>
                  <div style={{ display: 'flex', gap: '20px', marginTop: '24px' }}>
                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <a href="https://www.linkedin.com/company/finikelithium" style={{ color: '#fff' }}><Linkedin size={16} /></a>
                        <span style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '800' }}>LITHIUM</span>
                     </div>
                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <a href="https://www.linkedin.com/company/SPINOFFTECHNOPARK" style={{ color: '#fff' }}><Linkedin size={16} /></a>
                        <span style={{ fontSize: '10px', color: '#94a3b8', fontWeight: '800' }}>SPINOFF</span>
                     </div>
                  </div>
               </div>

               {/* SECTION 2: USEFUL LINKS */}
               <div className="f-glass-card">
                  <h4 style={{ marginBottom: '20px' }}>Useful links</h4>
                  <ul className="f-links">
                     <li><Link to="/about-us">About</Link></li>
                     <li><Link to="/contact-us">Contact Us</Link></li>
                     <li><Link to="/our-infrastructure">Our Infrastructure</Link></li>
                     <li><Link to="/our-journey">Our Journey</Link></li>

                  </ul>
               </div>

               {/* SECTION 3: CONTACT US (CORP & OVERSEAS) */}
               <div className="f-glass-card">
                  <h4 style={{ marginBottom: '20px' }}>Contact Us</h4>
                  <div className="contact-hub-item" style={{ marginBottom: '24px' }}>
                     <div className="contact-info">
                        <h5 style={{ color: '#6366f1' }}>CORPORATE ADDRESS</h5>
                        <p style={{ fontSize: '13px', color: '#fff' }}>SCO-117/118, Sec-43B, Chandigarh-160022</p>
                        <p style={{ fontSize: '12px', color: '#cbd5e1', marginTop: '4px' }}>sales@spinoff.in</p>
                        <p style={{ fontSize: '12px', color: '#cbd5e1', marginTop: '2px' }}>+91 97780-44000</p>
                     </div>
                  </div>
                  <div className="contact-hub-item" style={{ marginBottom: 0 }}>
                     <div className="contact-info">
                        <h5 style={{ color: '#6366f1' }}>OVERSEAS SALES OFFICE</h5>
                        <p style={{ fontSize: '13px', color: '#fff' }}>Unit 9/35/37 Jesica Rd, Campbellfield VIC 3061, Australia</p>
                        <p style={{ fontSize: '12px', color: '#cbd5e1', marginTop: '4px' }}>sales@spinoff.in</p>
                        <p style={{ fontSize: '12px', color: '#cbd5e1', marginTop: '2px' }}>+91 97780-44000</p>
                     </div>
                  </div>
               </div>

               {/* SECTION 4: CONTACT US (FACTORIES) */}
               <div className="f-glass-card">
                  <h4 style={{ marginBottom: '20px' }}>Contact Us</h4>
                  <div className="contact-hub-item" style={{ marginBottom: '24px' }}>
                     <div className="contact-info">
                        <h5 style={{ color: '#6366f1' }}>FACTORY ADDRESS 1</h5>
                        <p style={{ fontSize: '13px', color: '#fff' }}>E-226, Ph-8B, Ind Area, SAS Nagar, Mohali, Punjab-160071</p>
                        <p style={{ fontSize: '12px', color: '#cbd5e1', marginTop: '4px' }}>sales@spinoff.in</p>
                        <p style={{ fontSize: '12px', color: '#cbd5e1', marginTop: '2px' }}>+91 97780-44000</p>
                     </div>
                  </div>
                  <div className="contact-hub-item" style={{ marginBottom: 0 }}>
                     <div className="contact-info">
                        <h5 style={{ color: '#6366f1' }}>FACTORY ADDRESS 2</h5>
                        <p style={{ fontSize: '13px', color: '#fff' }}>NH1, Village Aluna, Soanti, Teh-Rajpura, Rajpura, Punjab</p>
                        <p style={{ fontSize: '12px', color: '#cbd5e1', marginTop: '4px' }}>sales@spinoff.in</p>
                        <p style={{ fontSize: '12px', color: '#cbd5e1', marginTop: '2px' }}>+91 97780-44000</p>
                     </div>
                  </div>
               </div>

            </div>

            {/* SUBSCRIBE STRIP - EXACT TEXT */}
            <div className="f-ultra-subscribe" style={{ padding: '24px 48px', marginTop: '32px' }}>
               <div style={{ flex: 1 }}>
                  <h2 style={{ fontSize: '20px', fontWeight: '900', color: '#fff', margin: 0 }}>Subscribe us <span className="highlight-gradient">!</span></h2>
                  <p style={{ color: '#94a3b8', fontSize: '13px', marginTop: '4px' }}>For getting new product solutions</p>
               </div>
               <div style={{ flex: 1, position: 'relative' }}>
                  <form onSubmit={handleSubscribe} style={{ display: 'flex', gap: '16px', justifyContent: 'flex-end' }}>
                     <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="ENTER YOUR EMAIL"
                        className="f-input-glass"
                        style={{ width: '240px', padding: '10px 24px' }}
                     />
                     <button className="btn-3d btn-3d-primary" style={{ margin: 0, padding: '10px 32px', fontSize: '12px' }}>JOIN</button>
                  </form>
                  {message && <p style={{ fontSize: '10px', color: '#6366f1', marginTop: '8px', position: 'absolute', right: '40px' }}>{message}</p>}
               </div>
            </div>

            {/* BOTTOM COPYRIGHT - EXACT TEXT */}
            <div className="footer-bot-strip" style={{ marginTop: '32px', paddingTop: '24px' }}>
               <div style={{ color: '#94a3b8' }}>© 2026 Spinoff Technopark Ltd. All Rights Reserved</div>
               <div style={{ display: 'flex', alignItems: 'center', gap: '12px', color: '#fff' }}>
                  <ShieldCheck size={14} color="#6366f1" /> AUTHORIZED INDUSTRIAL HUB | MADE IN INDIA 🇮🇳
               </div>
            </div>

         </div>
      </footer>
   );
};

export default Footer;
